if (!customElements.get('back-in-stock-notify')) {
  class BackInStockNotify extends HTMLElement {
    constructor() {
      super();
      window.initLazyScript(this, this.init.bind(this));
    }

    init() {
      this.notifyBtn = this.querySelector('.js-bis-notify-btn');
      this.modal = this.querySelector('.js-bis-modal');
      this.overlay = this.querySelector('.js-bis-overlay');
      this.form = this.querySelector('.js-bis-form');
      this.nameInput = this.querySelector('.js-bis-name');
      this.phoneInput = this.querySelector('.js-bis-phone');
      this.countryCodeSelect = this.querySelector('.js-bis-country-code');
      this.submitBtn = this.querySelector('.js-bis-submit');
      this.successEl = this.querySelector('.js-bis-success');
      this.errorEl = this.querySelector('.js-bis-error');
      this.productInfoEl = this.querySelector('.js-bis-product-info');
      this.webhookUrl = this.dataset.webhookUrl || '';

      this.currentVariantId = this.dataset.variantId;
      this.currentVariantTitle = this.dataset.variantTitle;
      this.productTitle = this.dataset.productTitle;
      this.productUrl = this.dataset.productUrl;
      this.productId = this.dataset.productId;

      // Parse variant availability data
      var dataEl = this.querySelector('[type="application/json"]');
      this.variantData = dataEl ? JSON.parse(dataEl.textContent) : [];

      // Cache the ATC area and dynamic checkout button to hide when sold out
      var productFormEl = this.closest('.product-info') ? this.closest('.product-info').querySelector('product-form') : null;
      this.atcArea = productFormEl ? productFormEl.querySelector('.product-info__add-to-cart') : null;
      this.dynamicCheckout = productFormEl ? productFormEl.querySelector('.product-info__dynamic-checkout-button') : null;

      // Bind to variant change event
      var variantPicker = this.closest('.product-info') ? this.closest('.product-info').querySelector('variant-picker') : null;
      if (variantPicker) {
        variantPicker.addEventListener('on:variant:change', this.handleVariantChange.bind(this));
      }

      // Button click opens modal
      this.notifyBtn.addEventListener('click', this.openModal.bind(this));

      // Close modal
      this.querySelector('.js-close-modal').addEventListener('click', this.closeModal.bind(this));
      this.overlay.addEventListener('click', this.closeModal.bind(this));
      var self = this;
      document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape' && self.modal.hasAttribute('open')) self.closeModal();
      });

      // Form submission
      this.form.addEventListener('submit', this.handleSubmit.bind(this));

      // Set initial visibility
      var isAvailable = this.dataset.variantAvailable === 'true';
      this.updateVisibility(!isAvailable);
    }

    handleVariantChange(evt) {
      if (evt.detail.variant) {
        var variant = evt.detail.variant;
        this.currentVariantId = variant.id;
        this.currentVariantTitle = variant.title;
        this.updateVisibility(!variant.available);
      } else {
        this.updateVisibility(false);
      }
    }

    updateVisibility(show) {
      this.notifyBtn.hidden = !show;
      if (this.atcArea) this.atcArea.hidden = show;
      if (this.dynamicCheckout) this.dynamicCheckout.hidden = show;
    }

    openModal() {
      var info = this.currentVariantTitle && this.currentVariantTitle !== 'Default Title'
        ? this.productTitle + ' — ' + this.currentVariantTitle
        : this.productTitle;
      this.productInfoEl.textContent = info;

      this.nameInput.value = '';
      this.nameInput.classList.remove('is-invalid');
      this.phoneInput.value = '';
      this.phoneInput.classList.remove('is-invalid');
      this.form.hidden = false;
      this.successEl.hidden = true;
      this.errorEl.hidden = true;
      this.submitBtn.disabled = false;
      this.submitBtn.textContent = this.submitBtn.dataset.text;

      this.modal.setAttribute('open', '');
      document.body.style.overflow = 'hidden';
    }

    closeModal() {
      this.modal.removeAttribute('open');
      document.body.style.overflow = '';
    }

    handleSubmit(evt) {
      evt.preventDefault();

      var name = this.nameInput.value.trim();
      if (!name) {
        this.nameInput.classList.add('is-invalid');
        return;
      }
      this.nameInput.classList.remove('is-invalid');

      var phone = this.phoneInput.value.trim().replace(/\D/g, '');
      if (!phone || phone.length < 4) {
        this.phoneInput.classList.add('is-invalid');
        return;
      }
      this.phoneInput.classList.remove('is-invalid');

      // Loading state
      this.submitBtn.disabled = true;
      this.submitBtn.classList.add('is-loading');
      this.submitBtn.textContent = this.submitBtn.dataset.loadingText;
      this.errorEl.hidden = true;

      var countryCode = this.countryCodeSelect.value;
      var fullPhone = countryCode + phone;

      // Build GET URL with query params — avoids all CORS issues
      var params = new URLSearchParams({
        phone: fullPhone,
        product: this.productTitle,
        variant: this.currentVariantTitle,
        name: name
      });

      var url = this.webhookUrl + '?' + params.toString();

      // Use image beacon — works cross-origin without CORS
      var img = new Image();
      var self = this;

      img.onload = img.onerror = function() {
        // Both onload and onerror mean the request was sent
        // (server may not return an image, so onerror is expected)
        self.form.hidden = true;
        self.successEl.hidden = false;
      };

      img.src = url;
    }
  }

  customElements.define('back-in-stock-notify', BackInStockNotify);
}
